export default {
  surveyInstanceCustomReportingDate: "",
  get SurSurveyInstanceCustomReportingDate() {
    return this.surveyInstanceCustomReportingDate;
  },
  set SurSurveyInstanceCustomReportingDate(value) {
    this.surveyInstanceCustomReportingDate = value;
    this.raiseChangedEvent("SurveyInstanceCustomReportingDate", value);
  },

  surveyInstanceVisibleInNotification: 0,
  get SurveyInstanceVisibleInNotification() {
    return this.surveyInstanceVisibleInNotification;
  },
  set SurveyInstanceVisibleInNotification(value) {
    this.surveyInstanceVisibleInNotification = value;
    this.raiseChangedEvent("SurveyInstanceVisibleInNotification", value);
  },

  surveyInstanceExternalInterface: 0,
  get SurveyInstanceExternalInterface() {
    return this.surveyInstanceExternalInterface;
  },
  set SurveyInstanceExternalInterface(value) {
    this.surveyInstanceExternalInterface = value;
    this.raiseChangedEvent("SurveyInstanceExternalInterface", value);
  },

  surveyInstanceLocationNotification: 0,
  get SurveyInstanceLocationNotification() {
    return this.surveyInstanceLocationNotification;
  },
  set SurveyInstanceLocationNotification(value) {
    this.surveyInstanceLocationNotification = value;
    this.raiseChangedEvent("SurveyInstanceLocationNotification", value);
  },

  surveyInstanceQueryTool: 0,
  get SurveyInstanceQueryTool() {
    return this.surveyInstanceQueryTool;
  },
  set SurveyInstanceQueryTool(value) {
    this.surveyInstanceQueryTool = value;
    this.raiseChangedEvent("SurveyInstanceQueryTool", value);
  },

  surveyInstanceDashboard: 0,
  get SurveyInstanceDashboard() {
    return this.surveyInstanceDashboard;
  },
  set SurveyInstanceDashboard(value) {
    this.surveyInstanceDashboard = value;
    this.raiseChangedEvent("SurveyInstanceDashboard", value);
  },

  surveyInstanceCheckExplorer: 0,
  get SurveyInstanceCheckExplorer() {
    return this.surveyInstanceCheckExplorer;
  },
  set SurveyInstanceCheckExplorer(value) {
    this.surveyInstanceCheckExplorer = value;
    this.raiseChangedEvent("SurveyInstanceCheckExplorer", value);
  },

  surveyInstanceAggregatedReport: 0,
  get SurveyInstanceAggregatedReport() {
    return this.surveyInstanceAggregatedReport;
  },
  set SurveyInstanceAggregatedReport(value) {
    this.surveyInstanceAggregatedReport = value;
    this.raiseChangedEvent("SurveyInstanceAggregatedReport", value);
  },

  surveyInstanceRawDataExports: 0,
  get SurveyInstanceRawDataExports() {
    return this.surveyInstanceRawDataExports;
  },
  set SurveyInstanceRawDataExports(value) {
    this.surveyInstanceRawDataExports = value;
    this.raiseChangedEvent("SurveyInstanceRawDataExports", value);
  },

  surveyInstanceFrequencies: 0,
  get SurveyInstanceFrequencies() {
    return this.surveyInstanceFrequencies;
  },
  set SurveyInstanceFrequencies(value) {
    this.surveyInstanceFrequencies = value;
    this.raiseChangedEvent("SurveyInstanceFrequencies", value);
  },

  surveyInstanceMediaExplorer: 0,
  get SurveyInstanceMediaExplorer() {
    return this.surveyInstanceMediaExplorer;
  },
  set SurveyInstanceMediaExplorer(value) {
    this.surveyInstanceMediaExplorer = value;
    this.raiseChangedEvent("SurveyInstanceMediaExplorer", value);
  },

  surveyInstanceNote: "",
  get SurveyInstanceNote() {
    return this.surveyInstanceNote;
  },
  set SurveyInstanceNote(value) {
    this.surveyInstanceNote = value;
    this.raiseChangedEvent("SurveyInstanceNote", value);
  },

  surveyInstanceLocationGuid: "",
  get SurveyInstanceLocationGuid() {
    return this.surveyInstanceLocationGuid;
  },
  set SurveyInstanceLocationGuid(value) {
    this.surveyInstanceLocationGuid = value;
    this.raiseChangedEvent("SurveyInstanceLocationGuid", value);
  },

  surveyInstanceUntil: null,
  get SurveyInstanceUntil() {
    return this.surveyInstanceUntil;
  },
  set SurveyInstanceUntil(value) {
    this.surveyInstanceUntil = value;
    this.raiseChangedEvent("SurveyInstanceUntil", value);
  },

  surveyInstanceSince: null,
  get SurveyInstanceSince() {
    return this.surveyInstanceSince;
  },
  set SurveyInstanceSince(value) {
    this.surveyInstanceSince = value;
    this.raiseChangedEvent("SurveyInstanceSince", value);
  },

  surveyInstanceDescription: null,
  get SurveyInstanceDescription() {
    return this.surveyInstanceDescription;
  },
  set SurveyInstanceDescription(value) {
    this.surveyInstanceDescription = value;
    this.raiseChangedEvent("SurveyInstanceDescription", value);
  },

  briefingDownloadGuid: "",
  get BriefingDownloadGuid() {
    return this.briefingDownloadGuid;
  },
  set BriefingDownloadGuid(value) {
    this.briefingDownloadGuid = value;
    this.raiseChangedEvent("BriefingDownloadGuid", value);
  },

  surveyDownloadGuid: "",
  get SurveyDownloadGuid() {
    return this.surveyDownloadGuid;
  },
  set SurveyDownloadGuid(value) {
    this.surveyDownloadGuid = value;
    this.raiseChangedEvent("SurveyDownloadGuid", value);
  },

  surveyInstanceType: "",
  get SurveyInstanceType() {
    return this.surveyInstanceType;
  },
  set SurveyInstanceType(value) {
    this.surveyInstanceType = value;
    this.raiseChangedEvent("SurveyInstanceType", value);
  },

  isReadonly: false,
  get IsReadonly() {
    return this.isReadonly;
  },
  set IsReadonly(value) {
    this.isReadonly = value;
    this.raiseChangedEvent("IsReadonly", value);
  },

  maxSurveyInstanceStatusId: null,
  get MaxSurveyInstanceStatusId() {
    return this.maxSurveyInstanceStatusId;
  },
  set MaxSurveyInstanceStatusId(value) {
    this.maxSurveyInstanceStatusId = value;
    this.raiseChangedEvent("MaxSurveyInstanceStatusId", value);
  },

  onlineState: null,
  get OnlineState() {
    return this.onlineState;
  },
  set OnlineState(value) {
    this.onlineState = value;
    this.raiseChangedEvent("OnlineState", value);
  },

  surveySkillLevel: 0,
  get SurveySkillLevel() {
    return this.surveySkillLevel;
  },
  set SurveySkillLevel(value) {
    this.surveySkillLevel = value;
    this.raiseChangedEvent("SurveySkillLevel", value);
  },

  surveyInstanceSkillLevel: 0,
  get SurveyInstanceSkillLevel() {
    return this.surveyInstanceSkillLevel;
  },
  set SurveyInstanceSkillLevel(value) {
    this.surveyInstanceSkillLevel = value;
    this.raiseChangedEvent("SurveyInstanceSkillLevel", value);
  },

  locationFree: null,
  get LocationFree() {
    return this.locationFree;
  },
  set LocationFree(value) {
    this.locationFree = value;
    this.raiseChangedEvent("LocationFree", value);
  },

  surveyInstanceCxReporting: 0,
  get SurveyInstanceCxReporting() {
    return this.surveyInstanceCxReporting;
  },
  set SurveyInstanceCxReporting(value) {
    this.surveyInstanceCxReporting = value;
    this.raiseChangedEvent("SurveyInstanceCxReporting", value);
  },

  surveyInstanceTotalPayment: 0,
  get SurveyInstanceTotalPayment() {
    return this.surveyInstanceTotalPayment;
  },
  set SurveyInstanceTotalPayment(value) {
    this.surveyInstanceTotalPayment = value;
    this.raiseChangedEvent("SurveyInstanceTotalPayment", value);
  },

  surveyInstanceScenarioGuid: "",
  get SurveyInstanceScenarioGuid() {
    return this.surveyInstanceScenarioGuid;
  },
  set SurveyInstanceScenarioGuid(value) {
    this.surveyInstanceScenarioGuid = value;
    this.raiseChangedEvent("SurveyInstanceScenarioGuid", value);
  },

  surveyInstanceWaveGuid: "",
  get SurveyInstanceWaveGuid() {
    return this.surveyInstanceWaveGuid;
  },
  set SurveyInstanceWaveGuid(value) {
    this.surveyInstanceWaveGuid = value;
    this.raiseChangedEvent("SurveyInstanceWaveGuid", value);
  },

  surveyInstanceAssignedShopperGuid: "",
  get SurveyInstanceAssignedShopperGuid() {
    return this.surveyInstanceAssignedShopperGuid;
  },
  set SurveyInstanceAssignedShopperGuid(value) {
    this.surveyInstanceAssignedShopperGuid = value;
    this.raiseChangedEvent("SurveyInstanceAssignedShopperGuid", value);
  },

  surveyInstanceAssignedLocalAgencyGuid: "",
  get SurveyInstanceAssignedLocalAgencyGuid() {
    return this.surveyInstanceAssignedLocalAgencyGuid;
  },
  set SurveyInstanceAssignedLocalAgencyGuid(value) {
    this.surveyInstanceAssignedLocalAgencyGuid = value;
    this.raiseChangedEvent("SurveyInstanceAssignedLocalAgencyGuid", value);
  },

  surveyInstanceInfo: "",
  get SurveyInstanceInfo() {
    return this.surveyInstanceInfo;
  },
  set SurveyInstanceInfo(value) {
    this.surveyInstanceInfo = value;
    this.raiseChangedEvent("SurveyInstanceInfo", value);
  },

  setDataCounter: 0,

  setData: function (data) {
    if (this.setDataCounter === 0) this.initialData = data;

    this.surveyInstanceCustomReportingDate =
      data.SurveyInstanceCustomReportingDate;
    this.SurveyInstanceVisibleInNotification =
      data.SurveyInstanceVisibleInNotification;
    this.SurveyInstanceExternalInterface = data.SurveyInstanceExternalInterface;
    this.SurveyInstanceLocationNotification =
      data.SurveyInstanceLocationNotification;
    this.SurveyInstanceQueryTool = data.SurveyInstanceQueryTool;
    this.SurveyInstanceDashboard = data.SurveyInstanceDashboard;
    this.SurveyInstanceCheckExplorer = data.SurveyInstanceCheckExplorer;
    this.SurveyInstanceAggregatedReport = data.SurveyInstanceAggregatedReport;
    this.SurveyInstanceRawDataExports = data.SurveyInstanceRawDataExports;
    this.SurveyInstanceFrequencies = data.SurveyInstanceFrequencies;
    this.SurveyInstanceMediaExplorer = data.SurveyInstanceMediaExplorer;
    this.SurveyInstanceNote = data.SurveyInstanceNote;
    this.SurveyInstanceLocationGuid = data.SurveyInstanceLocationGuid;
    this.surveyInstanceScenarioGuid = data.SurveyInstanceScenarioGuid;
    this.surveyInstanceWaveGuid = data.SurveyInstanceWaveGuid;
    this.SurveyInstanceAssignedShopperGuid =
      data.SurveyInstanceAssignedShopperGuid;
    this.SurveyInstanceAssignedLocalAgencyGuid =
      data.SurveyInstanceAssignedLocalAgencyGuid;
    this.SurveyInstanceInfo = data.SurveyInstanceInfo;
    if (data.SurveyInstanceDescription)
      this.SurveyInstanceDescription = data.SurveyInstanceDescription;
    if (data.BriefingDownloadGuid)
      this.BriefingDownloadGuid = data.BriefingDownloadGuid;
    if (data.SurveyDownloadGuid)
      this.SurveyDownloadGuid = data.SurveyDownloadGuid;
    if (data.SurveyInstanceType)
      this.SurveyInstanceType = data.SurveyInstanceType;
    if (data.IsReadonly != undefined) this.IsReadonly = data.IsReadonly;
    if (data.MaxSurveyInstanceStatusId)
      this.MaxSurveyInstanceStatusId = data.MaxSurveyInstanceStatusId;
    if (data.OnlineState) this.OnlineState = data.OnlineState;
    if (data.SurveySkillLevel) this.SurveySkillLevel = data.SurveySkillLevel;
    if (data.SurveyInstanceSkillLevel)
      this.SurveyInstanceSkillLevel = data.SurveyInstanceSkillLevel;
    if (data.LocationFree) this.LocationFree = data.LocationFree;

    this.SurveyInstanceCxReporting = data.SurveyInstanceCxReporting;
    if (data.SurveyInstanceTotalPayment)
      this.SurveyInstanceTotalPayment = data.SurveyInstanceTotalPayment;
    this.setDataCounter++;
  },

  initialData: {},

  valueChangedCallback: null,

  onChange: function (callback) {
    this.valueChangedCallback = callback;
  },

  changeCounter: 0,

  get Changed() {
    return this.changeCounter > 0;
  },

  raiseChangedEvent: function (propertyName, v) {
    if (this.valueChangedCallback) {
      this.valueChangedCallback(propertyName, v);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/CheckManagement/generalSettingsData.js